import { toast } from "react-toastify";
import { SubscriptionType } from "../type";
import { Button, Modal, Tag, Popconfirm, PopconfirmProps } from "antd";
import { useState } from "react";
import EditSubcriptionsModal from "./editSubcriptionsModal";
import EditFeaturesSubscriptionsModal from "./editFeatureOfSubModal";
import deleteSubcriptions from "../function/deleteSubcriptions";
const SubscriptionDisplayItem = ({ subscription, setTriggerReload }: { subscription: SubscriptionType; setTriggerReload: React.Dispatch<React.SetStateAction<number>> }) => {
    const confirmDelete: PopconfirmProps['onConfirm'] = (e) => {
        toast.info(`Delete subscription with id: ${subscription.id}`);
        setTriggerReload(prev => prev + 1);
        deleteSubcriptions(subscription.id).then((res) => {
            if (res) {
                toast.success("Subscription deleted successfully")
            }
        }).catch((error) => {
            console.error("Error deleting subscription:", error)
            toast.error("Failed to delete subscription")
        });
    };
    const [editModal, setEditModal] = useState(false);
    const [editFeature, setEditFeature] = useState(false);

    return (
        <div key={subscription.id} className="border p-4 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-2">
                <div className="flex flex-col">
                    <h3 className="text-xl font-semibold !m-0">{subscription.name}</h3>
                    <p className="text-gray-600 !m-0">{subscription.description}</p>
                    <p className="text-gray-800 font-bold !m-0">${subscription.price.toFixed(2)}</p>
                </div>
                <div>
                    <Modal
                        title="Edit Features of Subscription"
                        open={editFeature}
                        width={1000}
                        height={600}
                        style={{ top: 20 }}
                        onCancel={() => setEditFeature(false)}
                        footer={null}
                    >
                        <EditFeaturesSubscriptionsModal subcriptionId={subscription.id} onClose={() => {
                            setTriggerReload(prev => prev + 1);
                            setEditFeature(false)
                        }}
                        />
                    </Modal>
                    <Button
                        onClick={() => setEditFeature(true)}
                        className="mr-2 px-4 py-2 rounded-lg !bg-blue-600 !text-white hover:bg-blue-700 transition-colors">
                        Edit Features
                    </Button>
                    <Modal
                        title="Edit Subscription"
                        open={editModal}
                        width={800}
                        onCancel={() => setEditModal(false)}
                        footer={null}
                    >
                        <EditSubcriptionsModal subcriptionId={subscription.id} onClose={() => {
                            setTriggerReload(prev => prev + 1);
                            setEditModal(false)
                        }} />
                    </Modal>
                    <Button
                        onClick={() => setEditModal(true)}
                        className="px-4 py-2 rounded-lg !bg-green-600 !text-white hover:bg-green-700 transition-colors">
                        Edit
                    </Button>
                    <Popconfirm
                        title="Delete the Subscription"
                        description="Are you sure to delete this subscription?"
                        placement="topRight"
                        onConfirm={confirmDelete}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button className="ml-2 px-4 py-2 rounded-lg !bg-red-600 !text-white hover:bg-red-700 transition-colors">
                            Delete
                        </Button>
                    </Popconfirm>
                </div>
            </div>
            <h4 className="text-lg font-semibold mb-2">Features:</h4>
            {subscription.features.length === 0 ? (
                <p>No features available.</p>
            ) : (
                <div className="flex flex-wrap gap-y-2">
                    {subscription.features.slice(0, 10).map((feature: any) => (
                        <Tag key={feature.id} className="mb-2">{feature.name}</Tag>
                    ))}
                    {subscription.features.length > 10 && (
                        <Tag color="blue" className="mb-2">
                            +{subscription.features.length - 10} more
                        </Tag>
                    )}
                </div>
            )}
        </div>
    );
}
export default SubscriptionDisplayItem;